// import { centeredNotification } from '../../utils/utility';
import { ShowErrorInInterceptor } from './models/sendRequest.model';
import history from '../utils/history';
import { getCookieValue } from '../common/helpers';

const nativeApp = getCookieValue('source') === 'native' ? true : false;
export const errorHandler = (
	error: any,
	url: string,
	isShowErrorInInterceptor: boolean | ShowErrorInInterceptor,
	files?: File | File[]
): void => {
	if ([401, 403].includes(error?.response?.status) && !url.includes('auth')) {
		if(getCookieValue('source') === 'native') {
			history.push('/logout-handler');
		} else {
			window.location.replace('/logout');
		}
	}
	throw error;
};
